import { IApiResponse } from "../types/articles-plp-filters-types.types";
import { API_PATHS } from "../constants/api-paths";
import { isOpenInApp, stringToBoolean } from "@repo/shared-utils/pwa-utils";
import { request } from "../core/api.client";

export interface IInvestopediaFiltersResponse {
  filters: string[];
}

export interface IInvestopediaCategoryResponse {
  key: string;
  count: number;
}

export interface IInvestopediaCategoriesResponse {
  categories: IInvestopediaCategoryResponse[];
}

let resultsAbortController = new AbortController();
export const getInvestopediaResults = async (
  page: number,
  resultLimit: number,
  filters?: string[],
  category?: string
) => {
  resultsAbortController.abort();
  resultsAbortController = new AbortController();
  const locale = document.documentElement.lang;
  return (
    await request<IApiResponse>({
      method: "POST",
      url: API_PATHS.investopediaResults,
      data: {
        ...(filters?.length && { tag10: filters }),
        ...(category && { tag11: category }),
        offset: (page ?? 0) * resultLimit,
        limit: resultLimit,
        appFlag: stringToBoolean(
          isOpenInApp() || globalThis.window.location.href.includes("app-v")
        ),
        locale: locale,
      },
      signal: resultsAbortController.signal,
    })
  ).data;
};

let filtersAbortController = new AbortController();
export const getInvestopediaFilters = async () => {
  filtersAbortController.abort();
  filtersAbortController = new AbortController();
  const appFlag = stringToBoolean(
    isOpenInApp() || globalThis.window.location.href.includes("app-v")
  );
  const url =
    API_PATHS.investopediaFilters +
    (API_PATHS.investopediaFilters.includes("?") ? "&" : "?") +
    `appFlag=${appFlag}`;
  return (
    await request<IInvestopediaFiltersResponse>({
      method: "GET",
      url: url,
      signal: filtersAbortController.signal,
    })
  ).data.filters;
};

let categoriesAbortController = new AbortController();
export const getInvestopediaCategories = async (filters?: string[]) => {
  categoriesAbortController.abort();
  categoriesAbortController = new AbortController();
  return (
    await request<IInvestopediaCategoriesResponse>({
      method: "POST",
      url: API_PATHS.investopediaCategories,
      data: {
        ...(filters?.length && { tag10: filters }),
        appFlag: stringToBoolean(
          isOpenInApp() || globalThis.window.location.href.includes("app-v")
        ),
      },
      signal: categoriesAbortController.signal,
    })
  ).data.categories;
};
